import { createContext, useContext } from 'react';

// Page-level "Show advanced" flag from the Administrator Settings header.
// Consumed by nested components (e.g. RolePermissionsList) that render
// engineer-facing details behind the same toggle instead of adding their
// own switches. Defaults to false so components outside the provider
// still render safely.
export const AdminShowAdvancedContext = createContext<boolean>(false);

export const useAdminShowAdvanced = () => useContext(AdminShowAdvancedContext);
